import { Box, Flex, Stack } from '@chakra-ui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import IconDisc from 'components/icon-disc'

import theme from 'theme'

import type { IconProp } from '@fortawesome/fontawesome-svg-core'
import type { ReactElement } from 'react'

type IconProps = {
  source: IconProp
  color?: string
}

type LinkProps = {
  url: string
  isExternal?: boolean
}

type Props = {
  message: string | ReactElement
  status: 'info' | 'warning' | 'success'
  link?: LinkProps
  icon?: IconProps
}

const StatusColors = {
  info: theme.baseColors.primary.main,
  warning: theme.baseColors.danger.main,
  success: theme.baseColors.success.main,
}

const CardInfo = ({ icon, message, status, link }: Props) => {
  return (
    <Flex
      background={StatusColors[status]}
      p="12px 24px"
      align="center"
      justify="center"
      borderRadius="base"
      boxShadow="base"
    >
      <Flex align="center" mr="16px">
        {icon && <IconDisc size="40px" source={icon.source} color={icon.color} />}
        <Stack spacing="2px">
          <Box textStyle="body1Bold" color={theme.colors.white} userSelect="none">
            {message}
          </Box>
        </Stack>
      </Flex>
      <Stack direction="row" spacing="16px" align="center">
        {link && (
          <FontAwesomeIcon
            icon={['far', link.isExternal ? 'arrow-up-right-from-square' : 'chevron-right']}
            color={theme.colors.white}
          />
        )}
      </Stack>
    </Flex>
  )
}

export default CardInfo
